module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DSelect', {
    attrs: {
      "items": _vm.dSelectItems,
      "multiple": true,
      "placeholder": _vm.$t('vue2.substitution.choose_absence_user')
    },
    on: {
      "update": _vm.sendUpdate
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a73e70e8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsCreateDSelect.vue
// module id = 2080
// module chunks = 1